const getters = {
    wxConfig: state => state.wxConfig,
    readyKeyword: state => state.readyKeyword,
    searchParams: state => state.searchParams
}

export default getters





// WEBPACK FOOTER //
// ./src/vuex/getters.js